module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// C:/Users/donno/Local Sites/keystonehealth/app/public/wp-content/themes/keystone/node_modules/axios/index.js
// module id = 2
// module chunks = 0